const codes: { [alpha3: string]: string } = {
  AGO: 'AO',
  DZA: 'DZ',
  EGY: 'EG',
  BGD: 'BD',
  NER: 'NE',
  LIE: 'LI',
  NAM: 'NA',
  BGR: 'BG',
  BOL: 'BO',
  GHA: 'GH',
  CCK: 'CC',
  PAK: 'PK',
  CPV: 'CV',
  JOR: 'JO',
  LBR: 'LR',
  LBY: 'LY',
  MYS: 'MY',
  DOM: 'DO',
  PRI: 'PR',
  SXM: 'SX',
  PRK: 'KP',
  PSE: 'PS',
  TZA: 'TZ',
  BWA: 'BW',
  KHM: 'KH',
  UMI: 'UM',
  NIC: 'NI',
  TTO: 'TT',
  ETH: 'ET',
  PRY: 'PY',
  HKG: 'HK',
  SAU: 'SA',
  LBN: 'LB',
  SVN: 'SI',
  BFA: 'BF',
  CHE: 'CH',
  MRT: 'MR',
  HRV: 'HR',
  CHL: 'CL',
  CHN: 'CN',
  KNA: 'KN',
  SLE: 'SL',
  JAM: 'JM',
  SMR: 'SM',
  GIB: 'GI',
  DJI: 'DJ',
  GIN: 'GN',
  FIN: 'FI',
  URY: 'UY',
  THA: 'TH',
  STP: 'ST',
  SYC: 'SC',
  NPL: 'NP',
  CXR: 'CX',
  LAO: 'LA',
  YEM: 'YE',
  BVT: 'BV',
  ZAF: 'ZA',
  KIR: 'KI',
  PHL: 'PH',
  ROU: 'RO',
  VIR: 'VI',
  SYR: 'SY',
  MAC: 'MO',
  MAF: 'MF',
  MLT: 'MT',
  KAZ: 'KZ',
  TCA: 'TC',
  PYF: 'PF',
  NIU: 'NU',
  DMA: 'DM',
  BEN: 'BJ',
  GUF: 'GF',
  BEL: 'BE',
  MSR: 'MS',
  TGO: 'TG',
  DEU: 'DE',
  GUM: 'GU',
  LKA: 'LK',
  SSD: 'SS',
  FLK: 'FK',
  GBR: 'GB',
  BES: 'BQ',
  GUY: 'GY',
  CRI: 'CR',
  CMR: 'CM',
  MAR: 'MA',
  MNP: 'MP',
  LSO: 'LS',
  HUN: 'HU',
  TKM: 'TM',
  SUR: 'SR',
  NLD: 'NL',
  BMU: 'BM',
  HMD: 'HM',
  TCD: 'TD',
  GEO: 'GE',
  MNE: 'ME',
  MNG: 'MN',
  MHL: 'MH',
  MTQ: 'MQ',
  BLZ: 'BZ',
  NFK: 'NF',
  MMR: 'MM',
  AFG: 'AF',
  BDI: 'BI',
  VGB: 'VG',
  BLR: 'BY',
  BLM: 'BL',
  GRD: 'GD',
  TKL: 'TK',
  GRC: 'GR',
  RUS: 'RU',
  GRL: 'GL',
  SHN: 'SH',
  AND: 'AD',
  MOZ: 'MZ',
  TJK: 'TJ',
  HTI: 'HT',
  MEX: 'MX',
  ZWE: 'ZW',
  LCA: 'LC',
  IND: 'IN',
  LVA: 'LV',
  BTN: 'BT',
  VCT: 'VC',
  VNM: 'VN',
  NOR: 'NO',
  CZE: 'CZ',
  ATF: 'TF',
  ATG: 'AG',
  FJI: 'FJ',
  IOT: 'IO',
  HND: 'HN',
  MUS: 'MU',
  ATA: 'AQ',
  LUX: 'LU',
  ISR: 'IL',
  FSM: 'FM',
  PER: 'PE',
  REU: 'RE',
  IDN: 'ID',
  VUT: 'VU',
  MKD: 'MK',
  COD: 'CD',
  COG: 'CG',
  ISL: 'IS',
  GLP: 'GP',
  COK: 'CK',
  COM: 'KM',
  COL: 'CO',
  NGA: 'NG',
  TLS: 'TL',
  TWN: 'TW',
  PRT: 'PT',
  MDA: 'MD',
  GGY: 'GG',
  MDG: 'MG',
  ECU: 'EC',
  SEN: 'SN',
  NZL: 'NZ',
  MDV: 'MV',
  ASM: 'AS',
  SPM: 'PM',
  CUW: 'CW',
  FRA: 'FR',
  LTU: 'LT',
  RWA: 'RW',
  ZMB: 'ZM',
  GMB: 'GM',
  WLF: 'WF',
  JEY: 'JE',
  FRO: 'FO',
  GTM: 'GT',
  DNK: 'DK',
  IMN: 'IM',
  AUS: 'AU',
  AUT: 'AT',
  SJM: 'SJ',
  VEN: 'VE',
  PLW: 'PW',
  KEN: 'KE',
  MYT: 'YT',
  WSM: 'WS',
  TUR: 'TR',
  ALB: 'AL',
  OMN: 'OM',
  TUV: 'TV',
  ALA: 'AX',
  BRN: 'BN',
  TUN: 'TN',
  PCN: 'PN',
  BRB: 'BB',
  BRA: 'BR',
  CIV: 'CI',
  SRB: 'RS',
  GNQ: 'GQ',
  USA: 'US',
  QAT: 'QA',
  SWE: 'SE',
  AZE: 'AZ',
  GNB: 'GW',
  SWZ: 'SZ',
  TON: 'TO',
  CAN: 'CA',
  UKR: 'UA',
  KOR: 'KR',
  AIA: 'AI',
  CAF: 'CF',
  SVK: 'SK',
  CYP: 'CY',
  BIH: 'BA',
  SGP: 'SG',
  SGS: 'GS',
  SOM: 'SO',
  UZB: 'UZ',
  ERI: 'ER',
  POL: 'PL',
  KWT: 'KW',
  GAB: 'GA',
  CYM: 'KY',
  VAT: 'VA',
  EST: 'EE',
  MWI: 'MW',
  ESP: 'ES',
  IRQ: 'IQ',
  SLV: 'SV',
  MLI: 'ML',
  IRL: 'IE',
  IRN: 'IR',
  ABW: 'AW',
  PNG: 'PG',
  PAN: 'PA',
  SDN: 'SD',
  SLB: 'SB',
  ESH: 'EH',
  MCO: 'MC',
  ITA: 'IT',
  JPN: 'JP',
  KGZ: 'KG',
  UGA: 'UG',
  NCL: 'NC',
  ARE: 'AE',
  ARG: 'AR',
  BHS: 'BS',
  BHR: 'BH',
  ARM: 'AM',
  NRU: 'NR',
  CUB: 'CU',
};

export default codes;
